// Mock data para KrolBolt

export const services = [
  {
    id: 1,
    title: "Reparación de Celulares",
    description: "Cambio de pantallas, baterías, conectores de carga y más. Diagnóstico gratuito.",
    icon: "Smartphone",
    features: ["Cambio de pantalla", "Reparación de batería", "Conectores de carga", "Cámaras"]
  },
  {
    id: 2,
    title: "Reparación de Notebooks",
    description: "Soluciones para tu laptop: hardware, software y actualización de componentes.",
    icon: "Laptop",
    features: ["Cambio de disco/SSD", "Actualización RAM", "Limpieza profunda", "Reparación teclado"]
  },
  {
    id: 3,
    title: "Reparación de Computadoras",
    description: "Armado, actualización y reparación de PC de escritorio.",
    icon: "Monitor",
    features: ["Armado de PC", "Actualización componentes", "Instalación Windows", "Limpieza hardware"]
  },
  {
    id: 4,
    title: "Reparación de Microondas",
    description: "Diagnóstico y reparación de microondas. Repuestos originales.",
    icon: "Cpu",
    features: ["Cambio de magnetrón", "Reparación placa", "Cambio de capacitor", "Mantenimiento"]
  },
  {
    id: 5,
    title: "Reparación de Smart TV",
    description: "Reparación de pantallas LED/LCD y componentes internos de Smart TV.",
    icon: "Monitor",
    features: ["Reparación pantalla", "Cambio de fuente", "Actualización firmware", "Calibración"]
  },
  {
    id: 6,
    title: "Soluciones de Software",
    description: "Instalación de sistemas operativos, recuperación de datos y optimización.",
    icon: "Code",
    features: ["Instalación SO", "Recuperación datos", "Eliminación virus", "Optimización"]
  },
  {
    id: 7,
    title: "Microelectrónica",
    description: "Reparación a nivel de componentes, soldadura y reballing.",
    icon: "Cpu",
    features: ["Reballing", "Microsoladura", "Diagnóstico avanzado", "Recuperación placa"]
  },
  {
    id: 8,
    title: "Mantenimiento Preventivo",
    description: "Limpieza, optimización y chequeo completo de tus equipos.",
    icon: "Wrench",
    features: ["Limpieza interna", "Cambio pasta térmica", "Diagnóstico completo", "Backup datos"]
  }
];

export const products = [
  {
    id: 1,
    name: "Cargador USB-C 65W",
    description: "Cargador rápido compatible con notebooks y celulares",
    price: 15000,
    category: "Accesorios",
    image: "https://images.unsplash.com/photo-1591290619762-c588f7b18902?w=400",
    stock: true
  },
  {
    id: 2,
    name: "Memoria RAM DDR4 8GB",
    description: "Memoria RAM 8GB DDR4 2666MHz para notebook",
    price: 25000,
    category: "Componentes",
    image: "https://images.unsplash.com/photo-1541385135674-84fbce45c81b?w=400",
    stock: true
  },
  {
    id: 3,
    name: "SSD 480GB",
    description: "Disco sólido SATA 480GB - Mejora la velocidad de tu PC",
    price: 35000,
    category: "Componentes",
    image: "https://images.unsplash.com/photo-1597872200969-2b65d56bd16b?w=400",
    stock: true
  },
  {
    id: 4,
    name: "Funda iPhone 14",
    description: "Funda protectora transparente con refuerzo",
    price: 5000,
    category: "Accesorios",
    image: "https://images.unsplash.com/photo-1601784551446-20c9e07cdbdb?w=400",
    stock: true
  },
  {
    id: 5,
    name: "Mouse Gaming RGB",
    description: "Mouse ergonómico con iluminación RGB y 7 botones",
    price: 12000,
    category: "Periféricos",
    image: "https://images.unsplash.com/photo-1527814050087-3793815479db?w=400",
    stock: true
  },
  {
    id: 6,
    name: "Teclado Mecánico",
    description: "Teclado mecánico retroiluminado switches azules",
    price: 28000,
    category: "Periféricos",
    image: "https://images.unsplash.com/photo-1587829741301-dc798b83add3?w=400",
    stock: true
  },
  {
    id: 7,
    name: "Cable HDMI 2.0",
    description: "Cable HDMI 2m - 4K 60Hz",
    price: 3000,
    category: "Accesorios",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400",
    stock: true
  },
  {
    id: 8,
    name: "Webcam Full HD",
    description: "Webcam 1080p con micrófono integrado",
    price: 18000,
    category: "Periféricos",
    image: "https://images.unsplash.com/photo-1585829365295-ab7cd400c167?w=400",
    stock: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: "María González",
    text: "Excelente servicio! Me repararon la pantalla del celular en el día. Muy profesionales.",
    rating: 5
  },
  {
    id: 2,
    name: "Carlos Rodríguez",
    text: "Recuperaron datos de mi notebook que creía perdidos. Increíble trabajo!",
    rating: 5
  },
  {
    id: 3,
    name: "Laura Martínez",
    text: "Precios justos y atención rápida. Me actualizaron la RAM y ahora va volando.",
    rating: 5
  }
];

export const orders = [
  {
    id: "ORD-001",
    customer: "Juan Pérez",
    email: "juan@example.com",
    phone: "3512345678",
    products: [
      { name: "Cargador USB-C 65W", quantity: 1, price: 15000 }
    ],
    total: 15000,
    status: "pending",
    paymentMethod: "qr",
    date: "2025-01-15T10:30:00"
  },
  {
    id: "ORD-002",
    customer: "Ana López",
    email: "ana@example.com",
    phone: "3517654321",
    products: [
      { name: "SSD 480GB", quantity: 1, price: 35000 },
      { name: "Memoria RAM DDR4 8GB", quantity: 1, price: 25000 }
    ],
    total: 60000,
    status: "completed",
    paymentMethod: "transfer",
    date: "2025-01-14T15:20:00"
  }
];